<script lang="ts" setup>
	import CookieSettingsTrigger from '@/views/components/cookie-settings-trigger.vue';
</script>

<template>
	<div class="container mx-auto py-12 sm:px-6 lg:px-8">
		<div class="grid grid-cols-2 gap-8 md:grid-cols-4">
			<div>
				<h3 class="text-foreground mb-4 font-semibold">Product</h3>
				<ul class="space-y-2">
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Features</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Pricing</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Security</a
						>
					</li>
				</ul>
			</div>
			<div>
				<h3 class="text-foreground mb-4 font-semibold">Company</h3>
				<ul class="space-y-2">
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>About</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Careers</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Contact</a
						>
					</li>
				</ul>
			</div>
			<div>
				<h3 class="text-foreground mb-4 font-semibold">Resources</h3>
				<ul class="space-y-2">
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Blog</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Documentation</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Support</a
						>
					</li>
				</ul>
			</div>
			<div>
				<h3 class="text-foreground mb-4 font-semibold">Legal</h3>
				<ul class="space-y-2">
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Privacy</a
						>
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Terms</a
						>
					</li>
					<li>
						<CookieSettingsTrigger />
					</li>
					<li>
						<a
							class="hover:text-foreground transition-colors"
							href="#"
							>Security</a
						>
					</li>
				</ul>
			</div>
		</div>
		<div class="border-border mt-12 border-t pt-8 text-center">
			<p>© 2024 ProzessWunder. All rights reserved.</p>
		</div>
	</div>
</template>
